import {sessionSetUserInfo,sessionRemoveUserInfo} from "@/assets/js/utils.session";
import store from '@/store/index.js'
import {isProduction} from "../../../devParams";
import axios from 'axios'
import {Message} from "element-ui";
import {isObject} from "my-tools-kit";
import qs from "qs"

/**
 * 登录成功后保存缓存数据
 * @param user
 */
export function loginSaveUserData(user){
  sessionSetUserInfo(user);
  store.commit("addUserdata", user);
  store.commit("changDialogShow",!user.isBindedWebOpenId);
}
/**
 * 退出登录时需要清楚的缓存数据
 */
export function loginOut(){
  sessionRemoveUserInfo();
  sessionStorage.removeItem("authList");
  store.commit("addUserdata", {});
}

/**
 * 获取微信扫码跳转origin
 * @returns {string|string}
 */
export function getWebLocationOrigin(){
  return isProduction ? location.origin : "https://qa2.huodaipin.com.cn" ;
}
/**
 * 保存微信扫码登录当前页页面参数
 */
export function saveWxLoginBeforePageParams(){
  const {path,query} = this.$route;
  const data = {
    path,
    query,
  };
  sessionStorage.setItem("wx_login_page_params",JSON.stringify(data));
}
export function getWxLoginBeforePageParams(){
  let data = {
    path:"/",
  };
  const str = sessionStorage.getItem("wx_login_page_params");
  if(str) data = JSON.parse(str);
  return data;
}

/**
 * 微信扫码code交换用户code
 */
export function wxCodeSwapUserCode(code,state){
  const url = "/api/wechatUser/loginNotifyNew";
  const data = {
    code,
    state,
  };
  return axios.get(url,{params:data})
    .then(res=>{
      if(["string","number"].includes(typeof res.data)&& res.data) return res;
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .catch(res=>{
      Message.error(res.message||"扫码登录失败");
      return Promise.reject(res);
    })
}

/**
 * 使用扫码登录
 */
export function wxQrCodeLogin(params) {
  const url = "/api/user/loginByWechatCode";
  return axios
    .post(url, qs.stringify(params))
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      if (!isObject(res.data)) return Promise.reject(new Error("扫码登录成功，返回数据异常"));
      return res;
    })
    .then(res=>{
      loginSaveUserData(res.data);
      const mobilePhone = JSON.stringify({
        account: res.data.mobilePhone,
        activeName: 0
      })
      localStorage.setItem('login-account', mobilePhone)
      return res;
    })
    .catch(res=>{
      Message.error(res.message||"扫码登录失败");
      return Promise.reject(res);
    })
}


/**
 * 获取登陆用户最新信息
 */
export function getUserLoginInfo(){
  let url = "/api/user/getUserLoginInfo/1";
  return axios.get(url)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .then(res=>{
      let data = res.data ||{};
      loginSaveUserData(data);
      return res;
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.login.js